export default {"src":"/_next/static/media/boating.e837ea5e.svg","height":19,"width":39,"blurWidth":0,"blurHeight":0};